'use-strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';
// js gallery
class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.drift = null;
    this.init();
  }
  init() {
    if (this.type === 'no_zoom') return;
    window.addEventListener('resize', this.responsive.bind(this));
    window.addEventListener('load', this.responsive.bind(this));
    if (document.readyState === 'complete') this.responsive();
  }
  initLightBox() {
    if (this.lightbox !== null) return;
    // Satu instance PhotoSwipe saja per galeri. Klik pada <a> ditangani langsung
    // oleh PhotoSwipe (index dihitung dari urutan DOM), tanpa membuat instance
    // baru pada setiap klik / setiap event resize.
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a.media-gallery__image',
      pswpModule: () => Photoswipe,
      counter: false,
      zoom: false,
      preloader: false,
      arrowPrev: false,
      arrowNext: false,
      close: false,
      loop: false,
      bgOpacity: 1,
      preload: [2, 2],
    });
    // Placeholder instan: pakai thumbnail yang sudah termuat. Jika thumbnail
    // belum termuat (lazy), pakai versi kecil (400px) dari gambar yang sama,
    // bukan file asli beresolusi penuh.
    this.lightbox.addFilter('domItemData', (itemData, element) => {
      const thumb = element.querySelector('img');
      if (thumb && thumb.complete && thumb.currentSrc) {
        itemData.msrc = thumb.currentSrc;
      } else if (itemData.src) {
        itemData.msrc = itemData.src.replace(/([?&])width=\d+/, '$1width=400');
      }
      return itemData;
    });
    this.lightbox.on('uiRegister', () => {
      const { pswp } = this.lightbox;
      pswp?.ui.registerElement({
        name: 'bls--close',
        isButton: true,
        tagName: 'button',
        html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
        onClick: () => {
          pswp.close();
        },
      });
      pswp?.ui.registerElement({
        name: 'bottomBar',
        className: 'pswp__bottom-bar',
        appendTo: 'wrapper',
        onInit: (el, pswp) => {
          let next, prev, counter;
          next = document.createElement('button');
          next.setAttribute('type', 'button');
          next.className = 'pswp__button pswp__button-next';
          next.innerHTML = `<svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>`;
          next.onclick = () => {
            pswp.next();
          };
          el.appendChild(next);

          counter = document.createElement('span');
          counter.className = 'pswp__counter';
          pswp.on('change', () => {
            counter.innerText =
              pswp.currIndex +
              1 +
              pswp.options.indexIndicatorSep +
              pswp.getNumItems();
          });
          el.appendChild(counter);

          prev = document.createElement('button');
          prev.setAttribute('type', 'button');
          prev.className = 'pswp__button pswp__button-prev';
          prev.innerHTML = `<svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>`;
          prev.onclick = () => {
            pswp.prev();
          };
          el.appendChild(prev);
        },
      });
    });
    this.lightbox.init();
    this.warmUpImages();
  }

  // Di mobile: unduh pelan-pelan (satu per satu, saat browser idle) semua gambar
  // ukuran lightbox, supaya saat gambar diketuk sudah ada di cache.
  warmUpImages() {
    if (this.warmed || window.innerWidth >= 768) return;
    const conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) {
      return;
    }
    const urls = [
      ...new Set(
        Array.from(this.querySelectorAll('a.media-gallery__image'))
          .map((a) => a.dataset.pswpSrc || a.getAttribute('href'))
          .filter(Boolean)
      ),
    ];
    if (!urls.length) return;
    this.warmed = true;
    const run = () => {
      let i = 0;
      const next = () => {
        if (i >= urls.length) return;
        const img = new Image();
        img.decoding = 'async';
        img.onload = img.onerror = next;
        img.src = urls[i++];
      };
      next();
    };
    const start = () =>
      'requestIdleCallback' in window
        ? window.requestIdleCallback(run, { timeout: 4000 })
        : setTimeout(run, 1500);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }
   initDrift() {
    if (this.drift !== null) return;
    var allTriggers = this.querySelectorAll('.drift-trigger');
    var paneContainer = this.closest('.sec__featured-product').querySelector(
      '.zoom-external-area'
    );
    if (allTriggers.length != 0) {
      allTriggers.forEach( (trigger) => {
        const inlineContainer = trigger.closest('[data-pane-container]');
        const zoomOption = this.zoomOption;
        if (zoomOption === 'inner-2') {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption === 'inner-2',
            zoomFactor: 3,
            containInline: paneContainer,
            paneContainer: inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        } else {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption,
            zoomFactor: 5,
            containInline: !!paneContainer,
            paneContainer:
              zoomOption === 'external' ? paneContainer : inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        }
      });
    }
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type === 'open_lightbox') {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        this.initDrift();
      }
    } else {
      if (this.type !== 'open_lightbox') {
        if (this.drift !== null) {
          this.drift.destroy();
          this.drift == null;
        }
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== 'undefined') {
      this.querySelector('.thumbnail-slide')?.swiper?.update();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.responsive.bind(this));
    window.removeEventListener('load', this.responsive.bind(this));
  }
}
customElements.define('zoom-action', ZoomAction);
